import { gql } from '@apollo/client';

export const PROJECT = {
    GET_FEATURED_ITEMS: gql`
        query GetFeaturedItems {
            getFeaturedItems {
                button_text
                image
                link
                subtitle
                title
                mobile_image
            }
        }
    `,
    GET_NOTIFICATION_DATA: gql`
        query getNotificationData {
            getNotification {
                active
                link
                message
                type
                button_text
            }
        }
    `,

    GET_LIST: gql`
        query GetProjects($limit: Int, $status: ProjectStatus) {
            retrieveProjects(limit: $limit, status: $status) {
                data {
                    id
                    slug
                    announced
                    events {
                        id
                        type
                        crowdfunding_type
                        name
                        start_date
                        chainId
                        saft_url
                        contract {
                            abi
                            address
                        }
                        challenge {
                            question
                            answers
                        }
                        token_price
                        total_allocation
                        refund_deadline
                        results_date
                        results_url
                        answer
                        uid
                        register_url
                        prize
                        how_to_participate
                        is_hidden
                        is_vesting_dates_not_confirmed
                        is_test
                        marketing_event {
                            image
                            title
                            link
                        }
                        ama_event {
                            start_date
                            end_date
                            title
                            link
                            type
                        }
                        event_details {
                            answer_hash
                            min_tier
                            durations
                            hardcap
                            second_round_cap
                            vesting {
                                start
                                cliff
                                duration
                                initial_unlock_percent
                            }
                        }
                    }
                    teaser
                    subtitle
                    status
                    name
                    logo
                    square_logo
                    hero
                    hero_video
                    social_platforms {
                        type
                        url
                    }
                    token {
                        ticker
                        network
                        tge
                        fully_diluted_valuation
                        initial_market_cap
                        initial_market_cap_ex_liquidity
                        total_supply
                    }
                    description
                    explanation
                    faqs {
                        question
                        answer
                    }
                    links {
                        roadmap {
                            href
                            image
                        }
                        team {
                            href
                            image
                        }
                        tokenomics {
                            href
                            image
                        }
                        website {
                            href
                            image
                        }
                    }
                    created_at
                    project_type
                    whitepaper
                    climate_impact
                }
            }
        }
    `,
    GET_TOKEN_PRICES: gql`
        query GetTokenPrices($tokens: [TokenPriceInput]!) {
            getTokenPrices(tokens: $tokens)
        }
    `,
    GET_TOKEN_PRICE: gql`
        query GetTokenPrice($symbol: String!, $tokenAddr: String) {
            getTokenPrice(symbol: $symbol, token_addr: $tokenAddr)
        }
    `,
    GET_ONE: gql`
        query GetProject($slug: String) {
            retrieveProject(slug: $slug) {
                id
                slug
                announced
                events {
                    id
                    type
                    crowdfunding_type
                    name
                    start_date
                    chainId
                    saft_url
                    contract {
                        abi
                        address
                    }
                    challenge {
                        question
                        answers
                    }
                    token_price
                    total_allocation
                    refund_deadline
                    results_date
                    results_url
                    answer
                    uid
                    register_url
                    prize
                    how_to_participate
                    is_hidden
                    is_vesting_dates_not_confirmed
                    is_test
                    marketing_event {
                        image
                        title
                        link
                    }
                    ama_event {
                        start_date
                        end_date
                        title
                        link
                        type
                    }
                    event_details {
                        answer_hash
                        min_tier
                        durations
                        hardcap
                        second_round_cap
                        vesting {
                            start
                            cliff
                            duration
                            initial_unlock_percent
                        }
                    }
                }
                teaser
                subtitle
                status
                name
                logo
                square_logo
                hero
                hero_images
                social_platforms {
                    type
                    url
                }
                token {
                    ticker
                    network
                    tge
                    fully_diluted_valuation
                    initial_market_cap
                    initial_market_cap_ex_liquidity
                    total_supply
                    circulating_supply_tge
                    circulating_supply_tge_percent
                    token_allocation_info {
                        type
                        amount
                        percentage
                    }
                }
                description
                explanation
                faqs {
                    question
                    answer
                }
                links {
                    roadmap {
                        href
                        image
                    }
                    team {
                        href
                        image
                    }
                    tokenomics {
                        href
                        image
                    }
                    website {
                        href
                        image
                    }
                }
                exchanges {
                    name
                }
                created_at
                project_type
                whitepaper
                climate_impact
            }
        }
    `,
    GET_PLATFORM_IMAGES: gql`
        query getProjectImages {
            retrieveImages {
                url
                id
            }
        }
    `,
    REGISTER_FOR_WHITELIST: gql`
        mutation registerForWhitelist(
            $event_id: Int!
            $event_answer: [String]
        ) {
            registerForWhitelist(
                event_id: $event_id
                event_answer: $event_answer
            )
        }
    `,
    IS_REGISTERED_FOR_WHITELIST: gql`
        query IsRegisteredForWhitelist($event_id: Int!) {
            isRegisteredForWhitelist(event_id: $event_id)
        }
    `,

    IS_UID_REGISTERED_FOR_WHITELIST: gql`
        query IsUidERegisteredForWhitelist($event_id: Int!, $user_id: String!) {
            isUidRegisteredForWhitelist(event_id: $event_id, user_id: $user_id)
        }
    `,
    GET_WHITELIST_SUMMARY: gql`
        query GetWhitelistSummary($event_id: Int!) {
            getWhitelistSummary(event_id: $event_id) {
                finalized
                num_whitelisted
                fcfs_registered
                ga_registered
                user_allocation {
                    address
                    allocation
                    allocation_wei
                    multiplier
                    power
                    power_wei
                    proof
                    refund_fee
                    tier
                    tier_name
                    user_id
                }
            }
        }
    `,
    RETRIEVE_HOMEPAGE_EVENTS: gql`
        query retrieveHomepageEvents(
            $main_event_name: ContentSectionType!
            $secondary_events_name: ContentSectionType!
        ) {
            retrieveMainEvents: retrieveContentSection(name: $main_event_name) {
                id
                name
                data {
                    key
                    value
                }
            }
            retrieveSecondaryEvents: retrieveContentSection(
                name: $secondary_events_name
            ) {
                id
                name
                data {
                    key
                    value
                }
            }
        }
    `,
};
